import { getTagsKey } from '@tribeplatform/react-sdk/utils/keys';
import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useCreateTag = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const tagsKey = getTagsKey();
    return useMutation(variables => client.mutation({
        name: 'createTag',
        args: {
            fields,
            variables,
        },
    }), {
        onMutate: () => {
            queryClient.cancelQueries(tagsKey);
        },
        onSettled: () => {
            queryClient.invalidateQueries(tagsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useCreateTag.js.map